module.exports = __webpack_public_path__ + "static/media/Promotion_Card_HK.74b862bf.png";